import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../images/Logo.avif'; // Ensure the logo path is correct
import '../styles/Header.css'; // Ensure the CSS file exists

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [user, setUser] = useState(null);
    const[profilename, setProfileName]=useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is logged in
        const token = localStorage.getItem("authToken");
        if (token) {
            setUser({ token }); // Store token as an object in state
        }
        // Retrieve user details from localStorage
        // Retrieve user details from localStorage
        const storedUser = JSON.parse(localStorage.getItem("userProfile"));
        if (storedUser && storedUser.firstname) {
            setProfileName(`${storedUser.firstname} ${storedUser.lastname || ""}`);
        }
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("selectedRoId");
        setUser(null); // Remove user data
        navigate("/dealer-login"); // Redirect to login page
    };

    return (
        <header className="header">
            <div className="logo-container">
                <img src={logo} alt="Logo" className="logo" />
                <div className="logo-text-container">
                    <span className="company-name">DriverGems</span>
                    <span className="tagline">The True Companion of the Journey!</span>
                </div>
            </div>
            <button className="hamburger" onClick={toggleMenu}>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
            </button>
            <nav className={`menu ${menuOpen ? 'active' : ''}`}>
                <ul>
                    <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li> 
                     {/* Show 'Dashboard' if logged in, otherwise 'Dealer Login' */}
        {user ? (
            <li><Link to="/Dashboard" onClick={() => setMenuOpen(false)}>Dashboard</Link></li>
        ) : (
            <><li><Link to="/dealer-login" onClick={() => setMenuOpen(false)}>Dealer Login</Link></li>{/*<li><Link to="/admin-login" onClick={() => setMenuOpen(false)}>Admin Login</Link></li>*/}
            </>
        )}
                 <li><Link to="/contacts" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>   
                </ul>
            </nav>
            {/* Profile & Logout Section */}
            {user && (
                <div className="profile-container">
                    <span className="profile-name">{profilename}</span>
                    <button className="logout-btn" onClick={handleLogout}>Logout</button>
                </div>
            )}
        </header>
    );
};

export default Header;
